var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.title)+" "),[_c('i',{staticClass:"el-icon-arrow-up",on:{"click":function($event){return _vm.click(1)}}}),_c('i',{staticClass:"el-icon-arrow-down",on:{"click":function($event){return _vm.click(0)}}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }